import { createContext, useContext } from 'react';
import { some, none } from 'fp-ts/Option';
import { ExpandModes } from 'utils/contexts/expansion';
import { NBAContextState } from 'modules/ai/nba/types';
import { defaultNBAData, defaultTemplateLocaleData } from 'modules/ai/nba/utils';

export const defaultState = {
  isLoading: false,
  isError: false,
  displayNBA: false,
  nbaData: some(defaultNBAData),
  nbaCampaignsData: [none],
  templatesData: none,
  reengagementModalExpandMode: ExpandModes.collapse,
  toggleIsModalShown: () => null,
  templateLocaleData: some(defaultTemplateLocaleData),
};

export const NBAContext = createContext<NBAContextState>(defaultState);

export const useNBAContext = () => useContext(NBAContext);
